import type { RPCCommand } from './RPCCommand';

/**
 * Generic registry for RPC command handlers.
 *
 * TCommandMap is the command map that defines which commands this side *receives*.
 * TContext is an optional context type forwarded to each command's run().
 */
export class RPCCommandRegistry<TCommandMap, TContext = void> {
    private commands: Map<string, RPCCommand<TCommandMap, any, TContext>> = new Map();

    register<K extends keyof TCommandMap>(name: K, command: RPCCommand<TCommandMap, K, TContext>): void {
        this.commands.set(name as string, command);
    }

    get(name: string): RPCCommand<TCommandMap, any, TContext> | undefined {
        return this.commands.get(name);
    }
}
